import { render, staticRenderFns } from "./ContractorResourceNotesModal.vue?vue&type=template&id=51fc64d3&scoped=true"
import script from "./ContractorResourceNotesModal.vue?vue&type=script&lang=ts"
export * from "./ContractorResourceNotesModal.vue?vue&type=script&lang=ts"
import style0 from "./ContractorResourceNotesModal.vue?vue&type=style&index=0&id=51fc64d3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc64d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fc64d3')) {
      api.createRecord('51fc64d3', component.options)
    } else {
      api.reload('51fc64d3', component.options)
    }
    module.hot.accept("./ContractorResourceNotesModal.vue?vue&type=template&id=51fc64d3&scoped=true", function () {
      api.rerender('51fc64d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ContractorResourceNotesModal.vue"
export default component.exports